<template>
	<div id="usuario-cuenta-saldo">
		<b-row class="justify-content-md-end">
			<b-col cols="4">
				<b-button variant="skycel" @click="displayForm()"><i class="fa fa-plus"></i> Número Skycel</b-button>
			</b-col>
		</b-row>

		<UiModal v-model="showingAddingModal">
			
			<div slot="header">
				Solicitar seguimiento de número Skycel
			</div>
			
			<div slot="footer" v-if="!isProcessing">
				<button class="dimmed"  @click="showingAddingModal = 0">
					Cancelar
				</button>
				<button @click="tryToLink()">
					Aplicar
				</button>
			</div>
			
			<div slot="footer" v-else>
				<button variant="outline" disabled> Procesando... </button>
			</div>
			
			<div id="formBody" class="p-3">
				<b-form @submit.prevent>

					<b-input-group prepend="Teléfono">
						<b-form-input v-model="form.msisdn" id="msisdn"/>
					</b-input-group>

					<b-input-group class="mt-3" prepend="PIN de confirmación de SKYCEL®" v-if="!!form.id">
						<b-form-input v-model="form.pin" id="pin"/>
					</b-input-group>

				</b-form>
			</div>
			
		</UiModal>

		<account-saldo-page v-for="numero in skyaccountGetNumerosSky" :key="numero.id" :msisdn="numero.msisdn" />

	</div>
</template>

<script>
import _ from 'lodash'
import UiModal from '../daniel/ui-modal'
import mobiscroll from '@mobiscroll/javascript'
import AccountSaldoPage from './account-saldo-page.vue';
import { mapActions, mapGetters } from 'vuex';

let formArchetype = {
	msisdn: null,
	id: null,
	pin: null
}

// formArchetype.msisdn = '(331) 587-4260'
// formArchetype.id = 90

export default {
	components: { UiModal, AccountSaldoPage },
	data: () => {
		return {
			mobi: {
				instance: null,
				instancePIN: null
			},
			isLoading: false,
			isProcessing: false,
			showingAddingModal: false,
			form: _.clone(formArchetype)
		}
	},
	computed: {
		...mapGetters(['skyaccountGetNumerosSky'])
	},
	methods: {
		...mapActions(['skyaccountUpdate', 'skyaccountTryToLinkNumber']),
		reviewMobis(){
			if(this.showingAddingModal){
				if(!this.mobi.instance)
					setTimeout(this.loadUpMobiPhone, 50)
				if(!this.mobi.instancePIN && !!this.form.id)
					setTimeout(this.loadUpMobiPIN, 50)
			}
			else {
				if(!!this.mobi.instance) {
					this.mobi.instance.clear()
					this.mobi.instance = null
				}
				if(!!this.mobi.instancePIN && !this.form.id){
					this.mobi.instancePIN.clear()
					this.mobi.instancePIN = null
				}
				
			} 
		},
		async reviewMOBIEneability(){
			if(!!this.form.id && this.showingAddingModal){
				this.mobi.instance.disable();
			} else if(this.showingAddingModal) {
				this.mobi.instance.enable();
			}
		},
		async tryToLink() {
			this.isProcessing = true
			try {
				let response = await this.skyaccountTryToLinkNumber(this.form)
				if(response.status && !!response.data &&  !!response.data.id){
					this.form.id = response.data.id
				}
				else if(response.status){
					await this.loadUp()
					this.showingAddingModal = false
				}
			} catch (e) {
				console.error(e)
				mobiscroll.snackbar({
					display: 'top',
					theme: 'ios',
					message: 'Ocurrió un error obteniendo la respuesta: ' + e,
					color: 'warning',
					duration: 7000
				})
			}
			this.isProcessing = false
		},
		displayForm() {
			this.showingAddingModal = true;
		},
		async loadUp() {
			await this.skyaccountUpdate()
		},
		async loadUpMobiPhone(){
			let id = 'msisdn';

			this.mobi.instance = mobiscroll.numpad('#' + id, {
				lang: 'es',
				fill: 'ltr',
				template: '(ddd) ddd-dddd',
				
				validate: (event, inst)  => {
					if (inst.isVisible()) {
						// Display the formatted value
						inst._markup[0].querySelector('.mbsc-np-dsp').innerHTML = inst.settings.formatValue(event.values, event.variables, inst) || '&nbsp;';
					}
					return {
						// Set the set button invalid until 10 chars filled
						invalid: event.values.length != 10
					};
				},

				formatValue: (numbers, variables, inst)  => {
					// Specify how the value will be formatted
					return (numbers.length > 2 ? '(' : '')
						+ numbers.slice(0, 3).join('')
						+ (numbers.length > 2 ? ') ' : '')
						+ numbers.slice(3, 6).join('')
						+ (numbers.length > 5 ? '-' : '')
						+ numbers.slice(6, 10).join('');
				},

				parseValue: (v, i)  => {
					if (v) {
						return v.replace('(', '').replace(') ', '').replace('-', '');
					}
				},
				
			});
			this.reviewMOBIEneability()
		},
		async loadUpMobiPIN(){
			let id = 'pin';
			this.mobi.instancePIN = mobiscroll.numpad('#' + id, {
				lang: 'es',
				fill: 'ltr',
				template: 'dddddd'
			});
			this.reviewMOBIEneability()
		}
	},
	async beforeMount() {
		this.isLoading = true;
		await this.loadUp()
		await this.reviewMobis()
		this.isLoading = false
	},
	watch: {
		'form.id'(){
			this.reviewMobis()
			this.reviewMOBIEneability()
		},
		showingAddingModal() {
			if (!this.showingAddingModal) {
				this.form = _.clone(formArchetype)
			}
			this.reviewMobis()
		}
	}
}
</script>
